import { StaticImageData } from "next/image";

import team_3 from "@/assets/img/update/team/team-1-3.png";
import team_4 from "@/assets/img/update/team/team-1-4.png";
import team_5 from "@/assets/img/update/team/shaheen.png";
import team_6 from "@/assets/img/update/team/team-1-6.jpeg";
import team_7 from "@/assets/img/update/team/team-1-7.jpeg";
import team_8 from "@/assets/img/update/team/team-1-8.jpeg";
import team_9 from "@/assets/img/update/team/team-1-9.jpeg";
import team_10 from "@/assets/img/update/team/team-1-10.jpeg";
import team_11 from "@/assets/img/update/team/team-1-11.jpg";
import team_12 from "@/assets/img/update/team/team-1-12.jpeg";
import team_13 from "@/assets/img/update/team/team-1-13.jpeg";
import team_14 from "@/assets/img/update/team/team-1-14.jpeg";
import team_15 from "@/assets/img/update/team/team-1-15.jpeg";

export interface TeamMember {
  id: number;
  thumb: StaticImageData;
  name: string;
  designasion: string;
  linkedin?: string;
  bio?: string;
}

export interface TeamGroup {
  id: number;
  category: string;
  team_data: TeamMember[];
}

export const teamMembers: TeamMember[] = [
  {
    id: 3,
    thumb: team_3,
    name: "Khaled Tahoun",
    designasion: "COO",
    linkedin: "https://www.linkedin.com/in/khaled-tahoun-9907b132/",
    bio: "bio_khaled_tahoun",
  },
  {
    id: 4,
    thumb: team_4,
    name: "Malik Zeeshan",
    designasion: "Blockchain Developer",
    linkedin: "https://www.linkedin.com/in/zeeshan-asghar-malik/",
    bio: "bio_malik_zeeshan",
  },
  {
    id: 5,
    thumb: team_5,
    name: "Shaheen Khan",
    designasion: "UI/UX Designer",
    linkedin: "https://www.linkedin.com/in/shaheen-mohammed-khan-42501a326/",
    bio: "bio_shaheen_khan",
  },
];

export const advisorMembers: TeamMember[] = [
  {
    id: 1,
    thumb: team_6,
    name: "Shadi Bjerami",
    designasion: "Procurement & supply chain expert",
    linkedin: "https://www.linkedin.com/in/shadibjerami/",
    bio: "bio_shadi_bjerami",
  },
  {
    id: 2,
    thumb: team_12,
    name: "Dr. Saif Yousif Alsewaidi",
    designasion: "Digital transformation strategist",
    linkedin: "https://www.linkedin.com/in/saifalsewaidi/",
    bio: "bio_saif_yousif_alsewaidi",
  },
  {
    id: 3,
    thumb: team_7,
    name: "Dr. Ammar Riadh",
    designasion: "Blockchain & AI researcher, cybersecurity specialist",
    linkedin: "https://www.linkedin.com/in/ammarriadh/",
    bio: "bio_ammar_riadh",
  },
  {
    id: 4,
    thumb: team_8,
    name: "Dr. Stefano Nardo di Virgilio Sabato",
    designasion: "Operations, supply chain, and finance consultant",
    linkedin: "https://www.linkedin.com/in/stefanosabatotemporarymanager/",
    bio: "bio_stefano_sabato",
  },
  {
    id: 5,
    thumb: team_9,
    name: "Roberto Pane",
    designasion: "Senior executive in industrial engineering & innovation",
    linkedin: "https://www.linkedin.com/in/robertopane/",
    bio: "bio_roberto_pane",
  },
  {
    id: 6,
    thumb: team_10,
    name: "Dr. Katja Raithel",
    designasion: "Diversity, inclusion & wellbeing expert in insurance",
    linkedin: "https://www.linkedin.com/in/katjaraithel/",
    bio: "bio_katja_raithel",
  },
  {
    id: 7,
    thumb: team_14,
    name: 'Rich O. ("The Well Digger")',
    designasion: "Web3 growth advisor",
    linkedin: "https://www.linkedin.com/in/thewelldigger/",
    bio: "bio_rich_o",
  },
  {
    id: 8,
    thumb: team_13,
    name: "William San Andres de la Torre",
    designasion: "Fintech & sustainability specialist",
    linkedin: "https://www.linkedin.com/in/william-san-andres-de-la-torre-1b2765115/",
    bio: "bio_william_san_andres",
  },
  {
    id: 9,
    thumb: team_11,
    name: "Hana Komić",
    designasion: "Corporate lawyer & trial monitoring officer",
    linkedin: "https://www.linkedin.com/in/hana-komi%C4%87-27774110a/",
    bio: "bio_hana_komic",
  },
  {
    id: 10,
    thumb: team_15,
    name: "Sarah Morton",
    designasion: "Chief Strategy Officer at MeetAmi Innovations Inc.",
    linkedin: "https://www.linkedin.com/in/sarahmortonvan/",
    bio: "bio_sarah_morton",
  },
];

const teamData: TeamGroup[] = [
  {
    id: 1,
    category: "cat1",
    team_data: teamMembers,
  },
  {
    id: 2,
    category: "cat2",
    team_data: advisorMembers,
  },
];

export default teamData;
